import type { ReactElement } from 'react';

import { Button } from '~/ui/core/button/Button';

export const ChoiceButtons = <T extends string>({
    ariaLabel,
    onChange,
    options,
    value,
}: {
    readonly ariaLabel: string;
    readonly onChange: (value: T) => void;
    readonly options: readonly { readonly label: string; readonly value: T }[];
    readonly value: T | undefined;
}): ReactElement => (
    <div aria-label={ariaLabel} className="flex flex-wrap gap-s" role="radiogroup">
        {options.map((option) => (
            <Button
                key={option.value}
                aria-checked={option.value === value}
                isActive={option.value === value}
                role="radio"
                size="sm"
                variant="secondary"
                onClick={() => onChange(option.value)}
            >
                {option.label}
            </Button>
        ))}
    </div>
);
